import './assets/theme.scss'

import './icons'

const Theme = (props) => props.children

export default Theme